<!--
The App shell with header toolbar, main drawer menu and router view area
-->
<template>
  <v-app>

    <v-navigation-drawer
      app
      v-model="newDrawer"
      disable-resize-watcher
      :mini-variant="minifyMenu"
      :temporary="!minifyMenu"
      :permanent="minifyMenu"
      hide-overlay
      width="280"
      clipped
    >
      <v-list class="pa-0">

        <v-list-tile avatar class="pb-2" v-show="!minifyMenu">
          <v-list-tile-avatar>
            <img src="./assets/pizzalogo.png">
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title>
              <span class="subheading">{{ site.title }}</span>
            </v-list-tile-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <v-btn icon @click.stop="newDrawer=false">
              <v-icon small color="grey">arrow_back</v-icon>
            </v-btn>
          </v-list-tile-action>

        </v-list-tile>

        <v-divider></v-divider>
        
        <v-list-tile router to="/">
          <v-list-tile-action><v-icon>dashboard</v-icon></v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Overview</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile router to="/pages">
          <v-list-tile-action><v-icon>file_copy</v-icon></v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Pages</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn icon @click.stop="alert('Start new page')">
              <v-icon small color="grey">add</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile router to="/menus">
          <v-list-tile-action><v-icon>restaurant_menu</v-icon></v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Food menus</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn icon @click.stop="alert('Start new Food Menu')">
              <v-icon small color="grey">add</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile router to="/articles">
          <v-list-tile-action><v-icon>library_books</v-icon></v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Articles</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        

        <v-list-group
          prepend-icon="settings"
          @click.native="function(){ if(minifyMenu){ minifyMenu = false; return true } }"
        >
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-title>Settings</v-list-tile-title>
            </v-list-tile>
          </template>
          <v-list-group
            no-action
            sub-group
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-title>Site options</v-list-tile-title>
              </v-list-tile>
            </template>

            <v-list-tile
              v-for="(admin, i) in admins"
              :key="i"
              @click=""
            >
              <v-list-tile-title v-text="admin[0]"></v-list-tile-title>
              <v-list-tile-action>
                <v-icon v-text="admin[1]"></v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list-group>

          <v-list-group
            sub-group
            no-action
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-title>Theme</v-list-tile-title>
              </v-list-tile>
            </template>
            <v-list-tile
              v-for="(crud, i) in cruds"
              :key="i"
              @click=""
            >
              <v-list-tile-title v-text="crud[0]"></v-list-tile-title>
              <v-list-tile-action>
                <v-icon v-text="crud[1]"></v-icon>
              </v-list-tile-action>
            </v-list-tile>
          </v-list-group>
        </v-list-group>

        <v-list-tile router to="/feedback">
          <v-list-tile-action><v-icon>chat_bubble</v-icon></v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Send feedback</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      
        <v-list-tile>
          <v-list-tile-action>
            <v-btn
            icon
            @click.stop="minifyMenu = !minifyMenu"
            >
            <v-icon v-if="!minifyMenu">chevron_left</v-icon>
            <v-icon v-if="minifyMenu">chevron_right</v-icon>
            </v-btn>
          </v-list-tile-action>
          <v-list-tile-title></v-list-tile-title>
        </v-list-tile>
      </v-list>

      
    </v-navigation-drawer>



    <v-toolbar app fixed clipped-left clipped-right>
      <v-toolbar-side-icon v-show="!minifyMenu" @mouseover="drawerMouseover" @click.native="newDrawer = !newDrawer"></v-toolbar-side-icon>
      
      <v-spacer></v-spacer>

      <v-avatar size="42">
        <img src="./assets/res360_logo.png">
      </v-avatar>
      <v-toolbar-text class="pl-2 title">Dante Pizza</v-toolbar-text>

      <v-spacer></v-spacer>
   
        <v-avatar size="20" color="red accent-3">
          <span class="white--text caption">3</span>
        </v-avatar>
      

      <v-menu
        transition="slide-y-transition"
        bottom
      >
        <template v-slot:activator="{ on }">
          <v-btn icon large v-on="on">
             <v-avatar size="36">
              <img src="https://randomuser.me/api/portraits/men/94.jpg" alt="Jack Nance">
            </v-avatar>
            
          </v-btn>
        </template>
        <v-list>
          <v-list-tile
            
            router
            :to="'/notifications'"
          >
            <v-list-tile-action>
              <v-badge overlap color="red accent-3">
                <template v-slot:badge>
                  <span class="white--text caption">3</span>
                </template>
                <v-icon>notifications</v-icon>
              </v-badge>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Notifications</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            
            router
            :to="'/profile'"
          >
            <v-list-tile-action>
              <v-icon>account_box</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Edit profile</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            
            router
            :to="'/logout'"
          >
            <v-list-tile-action>
              <v-icon>meeting_room</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Log out</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
     
      

    </v-toolbar>
    
<!-- 
  <v-sheet style="position: absolute; left:0;top:0;width:24px;height:100%;background:yellow;content:'';" @mouseover="newDrawer = true" @click.native="newDrawer = !newDrawer"></v-sheet>
    -->
    <v-content style="margin-left:24px;"> 
      <router-view></router-view>
    </v-content>

    <v-footer app></v-footer>

  </v-app>
</template>

<script>
import { db } from '@/main'


export default {
  name: 'App',
  components: {
    
  },
  data () {
    return {
      minifyMenu: false,
      admins: [
        ['Header / Footer', 'people_outline'],
        ['Navigation', 'settings'],
        ['Integrations', 'settings']
      ],
      cruds: [
        ['Fonts', 'add'],
        ['Colours', 'insert_drive_file'],
        ['Styling', 'update'],
        ['Animation', 'delete']
      ],
      newDrawer: false,
      mainMenuDrawer: false,
      contextDrawer: true, 
      menuItems: [
        { icon: 'dashboard', text: 'Site Overview', link: '/site-overview' },
        { icon: 'file_copy', text: 'Pages', link: '/pages' },
        { icon: 'settings', text: 'Settings', children: ['', ''] },
        { icon: 'chat_bubble', text: 'Send feedback' },
      ],
      menuChildren: [

      ],
      site: {
        title: 'Dante Pizza'
      },
      pages: [], // Get all the pages on the site
      sections: [], // Only holds the sections on the currently selected page
      blocks: [] // All blocks on the current page
    }
  },
  computed: {
    
  },
  firestore () {
    return {
      pages: db.collection('pages').orderBy('createdAt')
    }
  },
  methods: {
    drawerMouseover() {
      //mouseover is supported and if so open the drawer
      // if( this.$vuetify.breakpoint.name == 'xl' ||
      //     this.$vuetify.breakpoint.name == 'lg' ) {
      //       this.newDrawer = true
      //     }
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
